import type { RefObject } from 'react';
import { fadeFromTo, fadeTo } from 'util/animation/fade/fade';
import type { HeadingRef } from '../../../atoms/heading/Heading.data';
import { findTransitionController } from '../../../../util/core-transition-component';

interface WorkFilterVisualItemRefs {
  elementRef?: RefObject<HTMLElement | null>;
  titleRef?: RefObject<HeadingRef | null>;
  animationRef?: RefObject<HTMLDivElement | null>;
  isMobileViewport?: boolean;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, animationRef }: WorkFilterVisualItemRefs,
): void {
  const title = findTransitionController(titleRef);

  if (title) {
    timeline.add(title.getTimeline('in') as gsap.core.Timeline, 0);
  }

  if (animationRef?.current) {
    timeline.add(fadeFromTo(animationRef.current), 0);
    timeline.fromTo(
      animationRef.current,
      { scale: 0.7 },
      {
        scale: 1,
        duration: 0.5,
        clearProps: 'scale',
        ease: 'Power2.easeOut',
      },
      0,
    );
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, animationRef }: WorkFilterVisualItemRefs,
): void {
  const title = findTransitionController(titleRef);

  if (title) {
    timeline.add(title.getTimeline('out') as gsap.core.Timeline, 0);
  }

  if (animationRef?.current) {
    timeline.add(fadeTo(animationRef.current), 0);
    timeline.to(animationRef.current, { scale: 0.7, duration: 0.5, ease: 'Power2.easeOut' }, 0);
  }
}

export function setupScrollTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, isMobileViewport }: WorkFilterVisualItemRefs,
): void {
  if (titleRef?.current && !isMobileViewport) {
    timeline.fromTo([titleRef.current], { y: 80 }, { y: 0, ease: 'none' });
  }
}
